export const primaryFont = 'Titillium Web, sans-serif';
export const primaryFontSize = '16px';
export const primaryFontWeight = '600';
export const primaryFontLineHeight = '28px';
export const secondaryFont = 'Proxima Nova, sans-serif';
export const secondaryFontSize = '14px';
export const secondaryFontWeight = '400';
export const secondaryFontLineHeight = '20px';
